import { Link } from "react-router-dom";
import "./Navigation.scss";
import { GanreIcon } from "../../ui/Icon/GanreIcon";
import { useWindowResize } from "../hooks/useWindowResize";
import { FC } from "react";

interface NavigationProps {
  urlPathname: string
}

export const Navigation: FC<NavigationProps> = ({ urlPathname }) => {

  const resize = useWindowResize()


  return (
    <nav className="nav">
      <ul className="nav__list">
        <li className="nav__item">
          <Link className={urlPathname === '/' ? "nav__link nav__link_main active" : "nav__link nav__link_main"} to={'/'}>
            Главная
          </Link>
        </li>
        <li className="nav__item">
          <Link className={urlPathname === '/genres' ? "nav__link active" : "nav__link"} to={'genres'}>
            {resize ? <GanreIcon /> : 'Жанры'}
          </Link>
        </li>

      </ul>
    </nav>
  );
};
